module.exports = __webpack_public_path__ + "img/unreadIcon.bac57fe4.svg";